export default "__VITE_ASSET__C2TaTx66__"